var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2493px",
    height: "1011px",
    viewBox: "0 0 2493 1011",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1485.99399,126 L512.006015,126 C504.27067,126 497.270078,129.132831 492.202929,134.197397 C487.134231,139.263512 484,146.262666 484,153.993781 L484,821.006219 C484,828.733281 487.135405,835.733115 492.205403,840.800529 C497.273216,845.865759 504.273692,849 512.006015,849 L1485.99399,849 C1493.72933,849 1500.72992,845.867169 1505.79707,840.802603 C1510.86577,835.736488 1514,828.737334 1514,821.006219 L1514,153.993781 C1514,146.266719 1510.8646,139.266885 1505.7946,134.199471 C1500.72678,129.134241 1493.72631,126 1485.99399,126 Z",
    id: "Case",
    stroke: "#141C3A",
    strokeWidth: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438.00651,188 L558.993491,188 C555.683075,188 552.682902,189.344447 550.51102,191.51985 C548.342374,193.692012 547,196.692365 547,200.00645 L547,696.99355 C547,700.308186 548.341887,703.308877 550.51057,705.481075 C552.681551,707.655576 555.680873,709 558.993491,709 L1438.00651,709 C1441.31693,709 1444.3171,707.655553 1446.48898,705.48015 C1448.65763,703.307988 1450,700.307635 1450,696.99355 L1450,200.00645 C1450,196.691814 1448.65811,193.691123 1446.48943,191.518925 C1444.31845,189.344424 1441.31913,188 1438.00651,188 Z",
    id: "Case",
    stroke: "#6E07F3",
    strokeWidth: 8,
    fill: "#6E07F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.3498,849 L925.650197,849 L915.67888,978 L1083.32112,978 L1073.3498,849 Z",
    id: "Case",
    stroke: "#141C3A",
    strokeWidth: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.99794,978 L855.002063,978 C854.725775,978 854.475722,978.111351 854.294913,978.29242 C854.11177,978.475825 854,978.72964 854,979.009224 L854,992.5 C854,996.504554 855.623246,1000.12924 858.24776,1002.75286 C860.873069,1005.37728 864.500094,1007 868.506286,1007 L1130.49371,1007 C1134.49856,1007 1138.12553,1005.37638 1140.75119,1002.75162 C1143.37583,1000.12787 1145,996.503504 1145,992.5 L1145,979.009224 C1145,978.729299 1144.89016,978.475195 1144.7073,978.292074 C1144.52586,978.110372 1144.27457,978 1143.99794,978 Z",
    id: "Keyboard",
    stroke: "#141C3A",
    strokeWidth: 8,
    fill: "#FFFFFF",
    transform: "translate(999.500000, 992.500000) scale(1, -1) translate(-999.500000, -992.500000) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-6",
    stroke: "#141C3A",
    strokeWidth: 8,
    cx: 999.5,
    cy: 784.5,
    r: 18.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Case",
    stroke: "#141C3A",
    strokeWidth: 8,
    fill: "#FFFFFF",
    x: 389,
    y: 618,
    width: 198,
    height: 389,
    rx: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587,662 L389,662 L389,949.3 L587,949.3 L587,662 Z",
    id: "Case",
    stroke: "#141C3A",
    strokeWidth: 8,
    fill: "#141C3A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#141C3A",
    x: 441,
    y: 636,
    width: 95,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#141C3A",
    x: 477,
    y: 966,
    width: 22.8,
    height: 22.8,
    rx: 11.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-6",
    stroke: "#6E07F3",
    strokeWidth: 8,
    fill: "#6E07F3",
    cx: 445,
    cy: 805,
    r: 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-73",
    transform: "translate(480.000000, 779.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 0,
    y: 0,
    width: 70,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 0,
    y: 22,
    width: 50,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    x: 0,
    y: 44,
    width: 30,
    height: 8,
    rx: 4
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-7",
    stroke: "#141C3A",
    strokeWidth: 8,
    fill: "#5BE9B9",
    cx: 287.5,
    cy: 653.5,
    r: 153.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1940.00938,468 L1255.99062,468 C1248.25916,468 1241.26188,471.133776 1236.19718,476.200367 C1231.13223,481.267212 1228,488.267285 1228,495.999588 L1228,937.000412 C1228,944.727887 1231.13352,951.728895 1236.20008,956.79735 C1241.26541,961.864568 1248.2624,965 1255.99062,965 L1940.00938,965 C1947.74084,965 1954.73812,961.866224 1959.80282,956.799633 C1964.86777,951.732788 1968,944.732715 1968,937.000412 L1968,495.999588 C1968,488.272113 1964.86648,481.271105 1959.79992,476.20265 C1954.73459,471.135432 1947.7376,468 1940.00938,468 Z",
    id: "Case",
    stroke: "#141C3A",
    strokeWidth: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2018.00827,965 L1177.99173,965 C1177.71865,965 1177.47175,965.111504 1177.29288,965.290669 C1177.11164,965.472215 1177,965.723144 1177,966.000032 L1177,986 C1177,991.799799 1179.35082,997.049431 1183.15171,1000.84923 C1186.95346,1004.64987 1192.20576,1007 1198.00721,1007 L1997.99279,1007 C2003.79414,1007 2009.04606,1004.6495 2012.84764,1000.84902 C2016.6489,997.048852 2019,991.798941 2019,986 L2019,966.000032 C2019,965.723463 2018.88676,965.473035 2018.70547,965.291445 C2018.52699,965.112658 2018.28102,965 2018.00827,965 Z",
    id: "Keyboard",
    stroke: "#141C3A",
    strokeWidth: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653.29015,965.448554 L1541.30708,965.448967 C1543.25611,970.583795 1546.53017,975.065102 1550.70971,978.477486 C1556.04792,982.835864 1562.86606,985.448303 1570.29412,985.448303 L1624.30439,985.448303 C1631.73003,985.448303 1638.54753,982.834984 1643.88593,978.476324 C1648.06559,975.063744 1651.34039,970.582565 1653.29015,965.448554 Z",
    id: "Notch",
    stroke: "#141C3A",
    strokeWidth: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Screen",
    fill: "#5BE9B9",
    x: 1257,
    y: 511,
    width: 681.406563,
    height: 411.849582,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-69",
    transform: "translate(695.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#293347",
    cx: 282,
    cy: 197,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,59 L4,59 L4,494.001483 C4,499.526566 6.23819372,504.525363 9.85752439,508.14317 C13.4787717,511.762893 18.4821901,514 24.0086237,514 L429.991376,514 C435.517409,514 440.51969,511.761712 444.140462,508.142463 C447.760907,504.523543 450,499.523946 450,494.001483 L450,59 Z",
    id: "Case",
    stroke: "#141C3A",
    strokeWidth: 8,
    fill: "#141C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.991376,4 L24.0086237,4 C18.4826918,4 13.4805416,6.2388067 9.85984852,9.85877145 C6.23916527,13.4787263 4,18.479773 4,24.0037939 L4,51 L450,51 L450,24.0037939 C450,18.4814078 447.75992,13.4802878 444.13876,9.85985606 C440.517962,6.23978599 435.516192,4 429.991376,4 Z",
    id: "Case",
    stroke: "#141C3A",
    strokeWidth: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#141C3A",
    cx: 39,
    cy: 28,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#6E07F3",
    cx: 69,
    cy: 28,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#5BE9B9",
    cx: 99,
    cy: 28,
    r: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-72",
    transform: "translate(52.000000, 143.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#535B6B",
    opacity: 0.54,
    x: 0,
    y: 200,
    width: 18,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#535B6B",
    opacity: 0.54,
    x: 0,
    y: 0,
    width: 18,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,0 L61,0 C63.209139,-4.05812251e-16 65,1.790861 65,4 C65,6.209139 63.209139,8 61,8 L34,8 C31.790861,8 30,6.209139 30,4 C30,1.790861 31.790861,4.05812251e-16 34,0 Z",
    id: "Rectangle-11",
    fill: "#6E07F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,0 L106,0 C108.209139,-4.05812251e-16 110,1.790861 110,4 C110,6.209139 108.209139,8 106,8 L79,8 C76.790861,8 75,6.209139 75,4 C75,1.790861 76.790861,4.05812251e-16 79,0 Z",
    id: "Rectangle-11",
    fill: "#5BE9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,0 L174,0 C176.209139,-4.05812251e-16 178,1.790861 178,4 C178,6.209139 176.209139,8 174,8 L124,8 C121.790861,8 120,6.209139 120,4 C120,1.790861 121.790861,4.05812251e-16 124,0 Z",
    id: "Rectangle-11",
    fill: "#6E07F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,0 L266,0 C268.209139,-4.05812251e-16 270,1.790861 270,4 C270,6.209139 268.209139,8 266,8 L192,8 C189.790861,8 188,6.209139 188,4 C188,1.790861 189.790861,4.05812251e-16 192,0 Z",
    id: "Rectangle-11",
    fill: "#6E07F3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#535B6B",
    opacity: 0.54,
    x: 0,
    y: 40,
    width: 18,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#535B6B",
    opacity: 0.54,
    x: 0,
    y: 80,
    width: 18,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#535B6B",
    opacity: 0.54,
    x: 0,
    y: 120,
    width: 18,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#535B6B",
    opacity: 0.54,
    x: 0,
    y: 160,
    width: 18,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#535B6B",
    opacity: 0.54,
    x: 0,
    y: 240,
    width: 18,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#535B6B",
    opacity: 0.54,
    x: 0,
    y: 280,
    width: 18,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#6E07F3",
    x: 30,
    y: 40,
    width: 70,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#5BE9B9",
    x: 110,
    y: 40,
    width: 120,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#6E07F3",
    x: 240,
    y: 40,
    width: 50,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#5BE9B9",
    x: 30,
    y: 80,
    width: 50,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#6E07F3",
    x: 90,
    y: 80,
    width: 50,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#6E07F3",
    x: 150,
    y: 80,
    width: 30,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#6E07F3",
    x: 30,
    y: 120,
    width: 100,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#6E07F3",
    x: 140,
    y: 120,
    width: 70,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#6E07F3",
    x: 30,
    y: 160,
    width: 100,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#5BE9B9",
    x: 140,
    y: 160,
    width: 130,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#6E07F3",
    x: 30,
    y: 200,
    width: 70,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#5BE9B9",
    x: 110,
    y: 200,
    width: 70,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#6E07F3",
    x: 190,
    y: 200,
    width: 40,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#6E07F3",
    x: 30,
    y: 240,
    width: 130,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#5BE9B9",
    x: 30,
    y: 280,
    width: 60,
    height: 8,
    rx: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-68",
    transform: "translate(1598.000000, 319.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544,46 L-4,46 L-4,435.996452 C-4,443.73135 -0.865131059,450.731814 4.20316809,455.798837 C9.27186646,460.866259 16.2744973,464 24.0095943,464 L515.990406,464 C523.728624,464 530.729708,460.866278 535.796904,455.800358 C540.866019,450.73252 544,443.730706 544,435.996452 L544,46 Z",
    id: "Case",
    stroke: "#141C3A",
    strokeWidth: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.990406,-4 L24.0095943,-4 C16.2715741,-4 9.27074736,-0.867582329 4.20370813,4.195989 C-0.865876606,9.26210408 -4,16.2615785 -4,23.993162 L-4,54 L544,54 L544,23.993162 C544,16.2625292 540.864731,9.2639013 535.795334,4.19797463 C530.726836,-0.867054328 523.724798,-4 515.990406,-4 Z",
    id: "Case",
    stroke: "#141C3A",
    strokeWidth: 8,
    fill: "#141C3A"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#FFFFFF",
    cx: 39,
    cy: 25,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#6E07F3",
    cx: 69,
    cy: 25,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#5BE9B9",
    cx: 99,
    cy: 25,
    r: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-61",
    transform: "translate(219.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-6",
    stroke: "#6E07F3",
    strokeWidth: 9,
    cx: 116,
    cy: 116,
    r: 100
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,4 L105,4 L105,28 L129,28 L129,4 Z",
    id: "Rectangle-12",
    stroke: "#5BE9B9",
    strokeWidth: 8,
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,204 L104,204 L104,228 L128,228 L128,204 Z",
    id: "Rectangle-12",
    stroke: "#5BE9B9",
    strokeWidth: 8,
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,105 L4,105 L4,129 L28,129 L28,105 Z",
    id: "Rectangle-12",
    stroke: "#5BE9B9",
    strokeWidth: 8,
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216,
    y1: 26,
    x2: 216,
    y2: 101,
    id: "Line",
    stroke: "#141C3A",
    strokeWidth: 8,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216,
    y1: 131,
    x2: 216,
    y2: 206,
    id: "Line",
    stroke: "#141C3A",
    strokeWidth: 8,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#141C3A",
    cx: 216,
    cy: 23,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#141C3A",
    cx: 216,
    cy: 213,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,105 L203,105 L203,129 L227,129 L227,105 Z",
    id: "Rectangle-12",
    stroke: "#5BE9B9",
    strokeWidth: 8,
    fill: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    transform: "translate(90.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    fill: "#141C3A",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    fill: "#5BE9B9",
    x: 0,
    y: 90,
    width: 70,
    height: 70,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    fill: "#6E07F3",
    x: 0,
    y: 180,
    width: 70,
    height: 70,
    rx: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-65",
    transform: "translate(2253.000000, 800.000000)",
    stroke: "#141C3A",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-64",
    transform: "translate(116.000000, 51.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-8",
    cx: 60,
    cy: 60,
    r: 60
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-8",
    cx: 60,
    cy: 60,
    r: 35
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-8",
    fill: "#FFFFFE",
    cx: 96,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.929648,15 L8,15 C6.8954305,15 5.8954305,15.4477153 5.17157288,16.1715729 C4.44771525,16.8954305 4,17.8954305 4,19 L4,187 C4,192.522847 6.23857625,197.522847 9.85786438,201.142136 C13.4771525,204.761424 18.4771525,207 24,207 L161.929648,207 C167.452496,207 172.452496,204.761424 176.071784,201.142136 C179.691072,197.522847 181.929648,192.522847 181.929648,187 L181.929648,19 C181.929648,17.8954305 181.481933,16.8954305 180.758075,16.1715729 C180.034218,15.4477153 179.034218,15 177.929648,15 Z",
    id: "Rectangle-16",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,69 L97,69 C94.790861,69 92.790861,69.8954305 91.3431458,71.3431458 C89.8954305,72.790861 89,74.790861 89,77 L89,125 C89,127.209139 89.8954305,129.209139 91.3431458,130.656854 C92.790861,132.104569 94.790861,133 97,133 L133,133 C135.209139,133 137.209139,132.104569 138.656854,130.656854 C140.104569,129.209139 141,127.209139 141,125 L141,77 C141,74.790861 140.104569,72.790861 138.656854,71.3431458 C137.209139,69.8954305 135.209139,69 133,69 Z",
    id: "Rectangle-16",
    fill: "#5BE9B9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.5,
    y1: 16.5,
    x2: 114.5,
    y2: 62,
    id: "Line-2",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-78",
    transform: "translate(2080.000000, 948.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63,4.2 C46.7628284,4.2 32.0628284,10.7814142 21.4221213,21.4221213 C11.7068585,31.137384 5.37550352,44.2365545 4.34768901,58.8 L121.652311,58.8 C120.624496,44.2365545 114.293141,31.137384 104.577879,21.4221213 C93.9371716,10.7814142 79.2371716,4.2 63,4.2 Z",
    id: "Oval-8",
    stroke: "#141C3A",
    strokeWidth: 8.4,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#141C3A",
    x: 59,
    y: 5,
    width: 8,
    height: 13,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(0.000000, 885.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305,4 L63.0004913,4 C46.7079555,4 31.9578327,10.6038549 21.2808438,21.2808438 C10.6038549,31.9578327 4,46.7079555 4,63.0004913 C4,79.2930271 10.6038549,94.0431499 21.2808438,104.720139 C31.9578327,115.397128 46.7079555,122.000983 63.0004913,122.000983 L305,122.000983 C306.656854,122.000983 308.156854,121.32941 309.242641,120.243623 C310.328427,119.157837 311,117.657837 311,116.000983 L311,106.714581 C311,104.615568 310.188762,102.69507 308.854093,101.262095 C307.519425,99.8291203 305.661325,98.8836674 303.567603,98.7347425 C289.724779,97.750106 279.43458,94.2360117 272.535942,88.5261423 C265.266108,82.5090412 261.498047,74.0462139 261.498047,63.0004917 C261.498047,51.9399279 265.27438,43.3927706 272.627668,37.2316561 C279.576775,31.4091945 289.951486,27.7121049 303.949375,26.4527227 C305.952077,26.2142727 307.710948,25.2467668 308.971475,23.8331245 C310.237017,22.4138564 311,20.544302 311,18.5094409 L311,10 C311,8.34314575 310.328427,6.84314575 309.242641,5.75735931 C308.156854,4.67157288 306.656854,4 305,4 Z",
    id: "Rectangle-17",
    stroke: "#141C3A",
    strokeWidth: 8,
    fill: "#6E07F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.786115,27 L62,27 C52.0588745,27 43.0588745,31.0294373 36.5441559,37.5441559 C30.0294373,44.0588745 26,53.0588745 26,63 C26,72.9411255 30.0294373,81.9411255 36.5441559,88.4558441 C43.0588745,94.9705627 52.0588745,99 62,99 C170.896078,99 248.328246,99.207629 294.296506,99.6226771 L294.296501,99.622677 C286.250429,97.4498695 277.022582,94.3704156 270.470403,87.641048 C265.206835,82.235138 261.498047,74.5375027 261.498047,63 C261.498047,51.353038 265.276502,43.6274533 270.618803,38.2399335 C276.749875,32.0569662 285.175864,29.0416346 292.786115,27 Z",
    id: "Rectangle-19",
    stroke: "#141C3A",
    strokeWidth: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9252336,72 L260.074766,72 C262.242613,72 264,73.790861 264,76 C264,78.209139 262.242613,80 260.074766,80 L57.9252336,80 C55.757387,80 54,78.209139 54,76 C54,73.790861 55.757387,72 57.9252336,72 Z",
    id: "Rectangle-18",
    fill: "#141C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9252336,46 L260.074766,46 C262.242613,46 264,47.790861 264,50 C264,52.209139 262.242613,54 260.074766,54 L57.9252336,54 C55.757387,54 54,52.209139 54,50 C54,47.790861 55.757387,46 57.9252336,46 Z",
    id: "Rectangle-18",
    fill: "#141C3A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-94",
    transform: "translate(199.000000, 589.000000)",
    fill: "#141C3A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1542645,100.35679 C46.246682,95.9937764 41.3390995,91.6307627 36.431517,87.267749 C28.6107577,80.3225435 20.8124075,73.3550777 12.9916482,66.4098723 C11.198924,64.8293928 9.40619977,63.2266531 7.63588462,61.6461736 C7.63588462,63.7386394 7.63588462,65.8533654 7.63588462,67.9458312 C12.5434671,63.5828175 17.4510496,59.2198038 22.3586321,54.8567901 C30.1793914,47.9115846 37.9777416,40.9441188 45.798501,33.9989134 C47.5912251,32.4184339 49.3839493,30.8156942 51.1542645,29.2352147 C52.9021706,27.6769956 52.8797615,24.4937764 51.1542645,22.9355572 C49.2943131,21.2215161 46.694863,21.2660366 44.8125026,22.9355572 C39.9049202,27.2985709 34.9973377,31.6615846 30.0897552,36.0245983 C22.2689959,42.9698038 14.4706456,49.9372695 6.64988632,56.882475 C4.85716212,58.4629545 3.06443792,60.0656942 1.29412278,61.6461736 C-0.43137426,63.1821325 -0.43137426,66.4098723 1.29412278,67.9458312 C6.20170527,72.3088449 11.1092878,76.6718586 16.0168702,81.0348723 C23.8376295,87.9800777 31.6359798,94.9475435 39.4567391,101.892749 C41.2494633,103.473228 43.0421875,105.075968 44.8125026,106.656448 C46.5604087,108.214667 49.4511765,108.50405 51.1542645,106.656448 C52.7228982,104.964667 53.0142158,102.026311 51.1542645,100.35679 L51.1542645,100.35679 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.885873,29.2458043 C130.793456,33.608818 135.701038,37.9718317 140.608621,42.3348454 C148.42938,49.2800509 156.22773,56.2475166 164.048489,63.1927221 C165.841214,64.7732016 167.633938,66.3759413 169.404253,67.9564207 C169.404253,65.863955 169.404253,63.749229 169.404253,61.6567632 C164.49667,66.0197769 159.589088,70.3827906 154.681505,74.7458043 C146.860746,81.6910098 139.062396,88.6584755 131.241637,95.603681 C129.448912,97.1841605 127.656188,98.7869002 125.885873,100.36738 C124.137967,101.925599 124.160376,105.108818 125.885873,106.667037 C127.745824,108.381078 130.345274,108.336558 132.227635,106.667037 C137.135217,102.304023 142.0428,97.9410098 146.950382,93.5779961 C154.771142,86.6327906 162.569492,79.6653249 170.390251,72.7201194 C172.182975,71.1396399 173.9757,69.5369002 175.746015,67.9564207 C177.471512,66.4204618 177.471512,63.1927221 175.746015,61.6567632 C170.838432,57.2937495 165.93085,52.9307358 161.023267,48.5677221 C153.202508,41.6225166 145.404158,34.6550509 137.583398,27.7098454 C135.790674,26.1293659 133.99795,24.5266262 132.227635,22.9461468 C130.479729,21.3879276 127.588961,21.098544 125.885873,22.9461468 C124.317239,24.6379276 124.025922,27.5762838 125.885873,29.2458043 L125.885873,29.2458043 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5381028,126.571918 C73.8826459,122.565068 75.20478,118.558219 76.5493232,114.52911 C79.7538177,104.890411 82.9583122,95.2739726 86.1628067,85.635274 C90.0171637,74.015411 93.8715207,62.4178082 97.7482868,50.7979452 C101.087236,40.7585616 104.426184,30.7191781 107.765133,20.6797945 C109.356176,15.8047945 111.1489,10.9520548 112.627898,6.01027397 C112.650307,5.94349315 112.672716,5.87671233 112.695125,5.80993151 C113.434624,3.60616438 111.843581,0.845890411 109.557857,0.33390411 C107.092862,-0.22260274 104.829547,1.06849315 104.045231,3.45034247 C102.700687,7.45719178 101.378553,11.4640411 100.03401,15.4931507 C96.8295157,25.1318493 93.6250212,34.7482877 90.4205266,44.3869863 C86.5661696,56.0068493 82.7118126,67.6044521 78.8350465,79.2243151 C75.4960977,89.2636986 72.1571489,99.3030822 68.8182001,109.342466 C67.2271574,114.195205 65.4344332,119.047945 63.9554357,123.989726 C63.9330266,124.056507 63.9106176,124.123288 63.8882085,124.190068 C63.1487098,126.393836 64.7397525,129.15411 67.0254759,129.666096 C69.4904717,130.222603 71.753786,128.931507 72.5381028,126.571918 L72.5381028,126.571918 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroDevices);
export default __webpack_public_path__ + "static/media/hero-devices.e54cb1e91b72c0c2cda54364dda473d5.svg";
export { ForwardRef as ReactComponent };